import { useMemo } from 'react'
import type { TimelineSlot, RateTier } from '../types/electricity'
import { getSeason } from '../utils/electricity'
import { getIsraelTime, getIsraelDay } from '../utils/time'
import { PEAK_HOURS, RATES } from '../data/rates'

export function useTimelineSlots(): TimelineSlot[] {
  const now = new Date()
  const { hour: currentHour } = getIsraelTime(now)
  const season = getSeason(now)
  const day = getIsraelDay(now)

  return useMemo(() => {
    const slots: TimelineSlot[] = []
    const { start, end } = PEAK_HOURS[season]
    const seasonRates = RATES[season]

    for (let h = 0; h < 24; h++) {
      let tier: RateTier = 'offpeak'

      // Determine if this hour would be peak on today's day
      // Weekend off-peak: Thu 22:00 → Sun 17:00
      if (day === 'Friday' || day === 'Saturday') {
        // All day off-peak
      } else if (day === 'Thursday') {
        // Peak possible before 22:00
        if (h >= start && h < end) tier = 'peak'
      } else if (day === 'Sunday') {
        // Peak only from 17:00 onward
        if (h >= start && h < end) tier = 'peak'
      } else {
        // Mon-Wed: normal weekday
        if (h >= start && h < end) tier = 'peak'
      }

      const rateAgorot = tier === 'peak' ? seasonRates.peak : seasonRates.offpeak

      slots.push({ hour: h, tier, isCurrent: h === currentHour, rateAgorot })
    }

    return slots
  }, [currentHour, season, day])
}
